// extracted by mini-css-extract-plugin
export default {"stepsCard":"detail-form_stepsCard__K32nJ"};